import AddHomeIcon from '@mui/icons-material/AddHome';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import AddHospital from '../pages/Patient/AddHospital';
import UserDetails from '../pages/Users/UserDetails';
import RecordForm from '../pages/Users/RecordForm';
import PatientList from "../pages/Patient/PatientList"
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import Feedback from '../pages/Feedback/Feedback';
const PATH = {
    HOME: '/',
    MENU: [
        {
            name: 'Referred Patient List',
            path: '/',
            icon: LocalHospitalIcon,
            element: <PatientList/>,
            children: [
                {
                    name: 'Add Hospital',
                    path: '/referred-pateint-list/add',
                    element: <AddHospital/>,
                },
                {
                    name: 'Add Hospital',
                    path: '/referred-pateint-list/users/:patient_code',
                    element: <UserDetails/>,
                },
                {
                    name: 'Add Hospital',
                    path: '/referred-pateint-list/users/record_detail_form/:user_form_id',
                    element: <RecordForm/>,
                },
            ]
        },
        {
            name: "Feedback",
            path: "/feedback",
            icon: ThumbUpAltIcon,
            element: <Feedback/>
        }
    ],
    LOGIN: '/auth/login',
    CHECK_EMAIL: "/onboarding/check-email",
    PASSWORD_RESET: "/resetpassword",
}

export default PATH;